import React from 'react';
import './contactCard.scss';

function ContactCard(){
    return(
        <div className="contactCard d-flex flex-column text-center">
            <a href="https://github.com/JacxDev" target="_blank"><span><i className="fab fa-github"></i></span></a>
            <a href="https://twitter.com/JacxDev" target="_blank"><span><i className="fab fa-twitter"></i></span></a> 
            <a href="https://api.whatsapp.com/send?phone=+5213312400006" target="_blank"><span><i className="fab fa-whatsapp"></i></span></a> 
        </div>
    )
}

export default ContactCard;